import { render, staticRenderFns } from "./create-ththreshold.vue?vue&type=template&id=15c0bc9c&"
import script from "./create-ththreshold.vue?vue&type=script&lang=ts&"
export * from "./create-ththreshold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports